import type { AvailableGraphEntities } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import {
  type GraphState,
  emptyAvailableEntities,
  isTopologyGraphMetadata,
} from 'components/Graph/GraphState';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectAvailableEntities: (
  s: GraphState,
) => AvailableGraphEntities = createScopedSelector(() =>
  createSelector(prop('graphMetadata'), (graphMetadata) =>
    isTopologyGraphMetadata(graphMetadata)
      ? graphMetadata.availableEntities
      : emptyAvailableEntities,
  ),
);
